import { UseSignatureConsultPUBParams } from '../../../hooks/fetchers/useSignatureConsultPUB/useSignatureConsultPUB.types';
import { UseSignaturePaymentENTParams } from '../../../hooks/fetchers/useSignaturePaymentENT/useSignaturePaymentENT.types';
import {
  StaticGetEndpoints,
  StaticPostEndpoints,
} from '../../../types/api/endpoints/staticEndpoints';
import { api } from '../api';

export const PAYMENT_ENDPOINTS = Object.freeze({
  signatureENT: (data: UseSignaturePaymentENTParams) =>
    api.post(StaticPostEndpoints.SignatureENT, data),
  signatureProspect: (data: UseSignaturePaymentENTParams) =>
    api.post(StaticPostEndpoints.SignatureProspect, data),
  signatureConsultPUB: (data: UseSignatureConsultPUBParams) =>
    api.post(StaticPostEndpoints.SignatureConsultPUB, data),

  simulate: (data: UseSignaturePaymentENTParams) =>
    api.post(`/payment/ENT/simulate`, data),

  allReceipts: () => api.get(StaticGetEndpoints.AllReceipts),
  allSubscriptions: () => api.get(StaticGetEndpoints.AllSubscriptions),

  allReceiptsPUB: () => api.get(StaticGetEndpoints.AllReceiptsPUB),
  
  validatePaymentENT: (data: any) => api.post(StaticPostEndpoints.ValidatePaymentENT, data),
});
